import React from "react";
import {DataTableExProps} from "./models";
import {IconZoom} from "@tabler/icons-react";

interface DTTitleProps extends DataTableExProps<any> {
    id: string;

    title?: string;
    subTitle?: string;
    extraNode?: React.ReactNode;
    hasLengthPageSelector?: boolean;

    searchPlaceholder?: string;
}

export const PageLengthSelector: React.FC<{
    id: string,
    options: number[],
    currentPageLength: number,
    setPageLength: (page: number) => void,
    label1?: JSX.Element,
    label2?: JSX.Element,
}> = ({
          id,
          options,
          currentPageLength,
          setPageLength,
          label1 = <>Visualizza:</>,
          label2 = <>elementi</>,
      }) => {
    const elementId = `righeXpagina_${id}`;
    return <div className="inline-flex items-center">
        <div className="mr-4 basis-1/3">
            <label htmlFor={elementId}>{label1}</label>
        </div>
        <div className="mr-4 basis-1/3">
            <select id={elementId} name={elementId}
                    className="rounded-md border-gray-300 py-2 text-base max-sm:text-xs max-md:text-sm
                                        focus:border-blue-500 focus:outline-none focus:ring-blue-500"
                    value={currentPageLength}
                    onChange={(e) => setPageLength(parseInt((e.target.value === 'Tutti') ? '-1' : e.target.value))}>
                {options.map((item, index) => (
                    <option key={index} value={item}>{item === -1 ? 'Tutti' : item}</option>))}
            </select>
        </div>
        <div className="basis-1/3">
            <label htmlFor={elementId}>
                {label2}
            </label>
        </div>
    </div>

}
const DTTitle: React.FC<Omit<DTTitleProps, "currentPage" | "setPage">> = (props) => {
    const {dataTables, currentPageLength, setPageLength, currentSearch, setSearch} = props;
    const recordsFiltered = dataTables ? dataTables.recordsFiltered : 0;
    const hasLengthPageSelector = props.hasLengthPageSelector || true;
    const hasSearch = props.setSearch ? true : false;
    const searchPlaceholder = props.searchPlaceholder || 'Cerca';

    function onChangeSearch(e: React.ChangeEvent<HTMLInputElement>) {
        if (hasSearch && setSearch)
            setSearch(e.target.value);
    }

    return (<>
        {(props.title || props.subTitle || props.extraNode) &&
            <div className="mt-4 flex items-center">
                <div className="flex-auto">
                    {props.title && <h1 className="font-semibold text-gray-900 max-sm:text-md max-md:text-lg md:text-xl">{props.title}</h1>}
                    {props.subTitle && <p className="mt-2 text-sm max-sm:text-xm max-md:text-sm md:text-md">{props.subTitle}</p>}
                </div>
                {props.extraNode && props.extraNode}
            </div>
        }

        {(hasLengthPageSelector || hasSearch) &&
            <div className="flex flex-wrap mt-3 max-sm:text-xs max-md:text-sm">

                <div className="flex-1 w-1/2">
                    {hasLengthPageSelector &&
                        <PageLengthSelector currentPageLength={currentPageLength} setPageLength={setPageLength} id={props.id}
                                            options={[10, 25, 50, 100, (recordsFiltered <= 200) ? -1 : 200]}/>
                    }
                </div>
                <div className="flex-initial w-1/2">
                    {hasSearch &&
                        <div className="inline items-center">
                            <div className="relative w-2/3 -right-1/3 max-sm:w-full max-sm:left-0">
                                <input id={"cerca" + props.id} name={"cerca" + props.id} placeholder={searchPlaceholder}
                                       className="right-0 -ml-px block w-full rounded border border-gray-300 bg-white py-2 pl-3 pr-9
                                        text-sm font-medium max-sm:text-xs max-md:text-sm
                                        hover:bg-gray-50 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                       value={currentSearch}
                                       onChange={onChangeSearch}/>
                                <span className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                    <IconZoom className="h-6 w-6 text-gray-400"/>
                                </span>
                            </div>
                        </div>
                    }
                </div>
            </div>}
    </>)
};
export default DTTitle;